import { ProductRequestModel } from '@/models/product.model'
import ProductClient from '@/clients/product.client'

export default class ProductService {
    static async getProducts (data) {
        const productRequestData = new ProductRequestModel(data)
        return await ProductClient.getProducts(productRequestData)
    }
}
